import React, { useEffect } from 'react';
import './App.scss';
import { Header } from './components/header/Header.component';
import { InstanceLoader } from './components/instanceLoader/InstanceLoader.component';
import { GameCtxProvider } from './core/context/game.context';

function App() {
  useEffect(() => {
    // TODO comment with 3.0.1 or above
    // if (localStorage.getItem('loq-chl:major_v3.0.0-0') !== 'done') {
    //   let i = 0;
    //   while (localStorage.key(i)) {
    //     const key = localStorage.key(i);
    //     if (key.startsWith('loq-chl:') && key !== 'loq-chl:deviceId') {
    //       localStorage.removeItem(key);
    //       continue; // if i delete one key, idx will change for others
    //     }
    //     i++;
    //   }
    //   localStorage.setItem('loq-chl:major_v3.0.0', 'done');
    // }
    //------
  }, []);

  return (
    <div className="App">
      <GameCtxProvider>
        <Header />
        <InstanceLoader />
      </GameCtxProvider>
    </div>
  );
}

export default App;
